import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from 'rhinostyle';

const RhinopayPaymentEvent = ({ event }) => {
  const { formattedTimestamp } = event;

  return (
    <>
      <div className="convo__event__title" data-cypress="rhinopayPaymentEvent">
        <Icon bump="up" icon="rhinopay" className="convo__event__icon convo__event__icon--complete" />
        Payment <strong>Received</strong>
      </div>
      <div className="convo__event__subtext">
        {formattedTimestamp}
      </div>
    </>
  );
};

RhinopayPaymentEvent.propTypes = {
  event: PropTypes.object,
};

export default RhinopayPaymentEvent;
